import { FC, ReactNode } from 'react';

import { Box, Tooltip } from '@mui/material';

interface Props {
  onClick: () => void;
  tooltip?: string;
  disabled?: boolean;
  'data-testid'?: string;
  children: ReactNode;
}

const MapControlButton: FC<Props> = ({
  onClick,
  tooltip,
  disabled = false,
  'data-testid': testId,
  children,
}) => {
  const button = (
    <Box
      component="button"
      data-testid={testId}
      onClick={onClick}
      disabled={disabled}
      sx={{
        display: 'flex',
        width: 36,
        height: 36,
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        aspectRatio: '1/1',
        borderRadius: '9999px',
        border: 'none',
        background: 'transparent',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.4 : 1,
        transition: 'background 0.15s ease',
        '&:hover:not(:disabled)': {
          background: 'rgba(0, 0, 0, 0.06)',
        },
        '&:active:not(:disabled)': {
          background: 'rgba(0, 0, 0, 0.1)',
        },
        padding: 0,
        outline: 'none',
        '&:focus-visible': {
          outline: '2px solid #4592fa',
          outlineOffset: 2,
        },
      }}
    >
      {children}
    </Box>
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip} placement="top">
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
};

export default MapControlButton;
